import ProjectUsersFullCollection from "../../../../model2/project-user/collection-full"
import ProjectUserFull from "../../../../model2/project-user/project-user-full"
import Team from "../../../../model2/team/team";

export default function ProjectUser_checkDelete(projectUser: ProjectUserFull, projectUsers: ProjectUsersFullCollection) {

    // check not last full access user
    if (projectUser.access === gd.const.project.access.FULL && projectUsers.findFullAccessUsers().length <2) {

        return {
            canDelete: false,
            reasonCantDelete: "At least one user with full access is required."
        }
    }

    // check not Project owner
    if (projectUser.projectRole === gd.const.project.role.OWNER) {

        return {
            canDelete: false,
            reasonCantDelete: "Project owner cannot be removed."
        }
    }

    // we dont' do it anymore
    // // check not Project manager
    // if (projectUser.projectRole === gd.const.project.role.PROJECT_MANAGER) {
    //     canDelete = false;
    //     reasonCantDelete = "Project manager cannot be removed";
    // }

    // check not full access user (Organization/Settings/Full access)
    if (gd.ac.check.company.isFullAccess(projectUser.userId)) {

        return {
            canDelete: false,
            reasonCantDelete: "Organization managers or administrators cannot be removed."
        }
    }

    if (!_.isEmpty(projectUser.teams)) {

        const teamsList = projectUser.teams.map((team: Team)=> {
            return team.name
        }).join(", ")

        return {
            canDelete: false,
            reasonCantDelete: `You cannot remove "${projectUser.user.name}" because user is part of "${teamsList}" team(s).`
        }
    }

    //dont' delete inherited / upherited users...
    if (projectUser.inheritance !== 0) {

        return {
            canDelete: false,
            reasonCantDelete: "You cannot remove inherited users because the access mode is set to Inherited. To manage users manually, switch the access mode to Custom."
        }
    }

   return {
        canDelete: true
   }
}
